import { createContext, type FC, lazy, Suspense, useMemo, useState } from "react";

const Confetti = lazy(() => import("react-confetti"));

type ConfettiContextType = {
    isConfettiDropping: boolean;
    dropConfetti(): void;
    hideConfetti(): void;
};
export const ConfettiContext = createContext<ConfettiContextType>({
    isConfettiDropping: false,
    dropConfetti: () => undefined,
    hideConfetti: () => undefined,
});

export const ConfettiContextProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isConfettiDropping, setIsConfettiDropping] = useState(false);
    const value = useMemo(() => {
        return {
            isConfettiDropping: isConfettiDropping,
            dropConfetti: () => setIsConfettiDropping(true),
            hideConfetti: () => setIsConfettiDropping(false),
        };
    }, [isConfettiDropping]);

    return (
        <ConfettiContext.Provider value={value}>
            {children}
            {isConfettiDropping && (
                <Suspense fallback={<></>}>
                    <Confetti recycle={false} numberOfPieces={300} onConfettiComplete={value.hideConfetti} />
                </Suspense>
            )}
        </ConfettiContext.Provider>
    );
};
